import React from 'react';
import { connect } from 'react-redux';
import { Divider } from 'material-ui';
import { List, ListItem } from 'material-ui/List';
import _ from 'lodash';

import { withFetchTemplates } from '../../editor/components/controls/TemplateChanger';

import IconDrafts from 'material-ui/svg-icons/content/archive';
import IconInterest from 'material-ui/svg-icons/action/stars';
import IconStyle from 'material-ui/svg-icons/image/style';
import { TABS } from '../constants';

const selectedStyle = {
    backgroundColor: '#1a1a1a',
    color: '#00505b',
    // borderLeft: '15px solid #00505b',
};

const selectedStyleSecondary = {
    backgroundColor: '#000',
    color: '#00505b',
    // borderLeft: '5px solid #00505b',
};

const WDPMenuItem = ({ ...props }) => <ListItem {...props} />;
const WDPMenuHeader = ({ ...props }) => (
    <ListItem
        {...props}
        innerDivStyle={{ padding: '5px 16px' }}
        style={{
            fontSize: 12,
            fontWeight: 'bold',
            padding: 0,
            opacity: 0.7,
        }}
    />
);

const WDPMenuTemplateChangerItem = withFetchTemplates(({ templates = [], template, onTemplateChanged, ...props }) => {
    return (
        <WDPMenuItem
            {...props}
            nestedItems={templates
                .filter(t => !t.isHidden)
                .map(t => (
                    <WDPMenuItem
                        key={t._id}
                        primaryText={t.name}
                        style={template === t.id ? selectedStyleSecondary : {}}
                        onClick={() => {
                            onTemplateChanged(t.id);
                        }}
                        secondaryText={t.id}
                    />
                ))}
        />
    );
});

const WidgetPickerMenu = connect(({ user, widgetPicker }) => {
    return {
        interests: user.interests || [],
        tournament: _.get(widgetPicker, 'info.league.tournament'),
        team: _.get(widgetPicker, 'info.team.team'),
        player: _.get(widgetPicker, 'info.player.player'),
    };
})(({ interests, tab, params, onTabOpen, template, player, tournament, team, onTemplateChanged }) => {
    const isInterests = false;

    const selection = {};
    selection[TABS.LEAGUE] = tournament && tournament.name;
    selection[TABS.TEAM] = team && team.name;
    selection[TABS.PLAYER] = '';

    const TABS_INFO = {};
    TABS_INFO[TABS.ALL] = {
        primaryText: 'All widgets',
        onClick: () => {
            onTabOpen(TABS.ALL, {
                tournamentId: null,
                teamId: null,
                eventId: null,
                playerId: null,
            });
        },
    };
    TABS_INFO[TABS.LEAGUE] = {
        primaryText: 'League',
        secondaryText: tournament && tournament.name,
        disabled: !tournament,
        onClick: () => {
            onTabOpen(TABS.LEAGUE, {
                tournamentId: tournament && tournament.id,
                teamId: null,
                eventId: null,
                playerId: null,
            });
        },
    };
    TABS_INFO[TABS.TEAM] = {
        primaryText: 'Team',
        secondaryText: team && team.name,
        onClick: () =>
            onTabOpen(TABS.TEAM, {
                tournamentId: tournament && tournament.id,
                teamId: team && team.id,
                eventId: null,
                playerId: null,
            }),
    };
    TABS_INFO[TABS.PLAYER] = {
        primaryText: 'Player',
        disabled: !team,
        secondaryText: player && player.name,
        onClick: () =>
            onTabOpen(TABS.PLAYER, {
                tournamentId: tournament && tournament.id,
                teamId: team && team.id,
                eventId: null,
                playerId: null,
            }),
    };
    TABS_INFO[TABS.EVENT] = {
        primaryText: 'Matches',
        onClick: () =>
            onTabOpen(TABS.EVENT, {
                tournamentId: tournament && tournament.id,
                teamId: team && team.id,
                eventId: null,
                playerId: null,
            }),
    };

    return (
        <List style={{ margin: 15, paddingTop: 0 }}>
            <WDPMenuHeader primaryText="Widgets" />

            {[TABS.ALL, TABS.LEAGUE, TABS.TEAM, TABS.PLAYER, TABS.EVENT].map(key => (
                <WDPMenuItem
                    key={key}
                    style={tab === key ? selectedStyle : {}}
                    primaryText={key}
                    {...TABS_INFO[key] && TABS_INFO[key]}
                />
            ))}

            <WDPMenuItem
                leftIcon={<IconDrafts />}
                primaryText="Portfolio"
                style={tab === TABS.PORTFOLIO ? selectedStyle : {}}
                onClick={() => {
                    onTabOpen(TABS.PORTFOLIO, {});
                }}
            />

            <WDPMenuItem
                primaryText="Interests"
                leftIcon={<IconInterest />}
                initiallyOpen={isInterests}
                style={isInterests ? selectedStyle : {}}
                nestedListStyle={
                    isInterests
                        ? {
                              padding: 0,
                              background: '#1a1a1a',
                          }
                        : {}
                }
                nestedItems={interests.map(interest => {
                    const selected =
                        tab === 'league' && +params.tournamentId == (interest.ttIds.length && interest.ttIds[0]);
                    return (
                        <WDPMenuItem
                            key={interest._id}
                            primaryText={interest.name}
                            style={selected ? selectedStyleSecondary : {}}
                            onClick={() => {
                                if (interest.ttIds.length) {
                                    onTabOpen('league', { tournamentId: interest.ttIds[0] });
                                } else {
                                    alert('not implemented');
                                }
                            }}
                            secondaryText={_.compact([
                                interest.ttIds.map(id => `League #${id}`).join(', '),
                                interest.teamIds.map(id => `Team #${id}`).join(', '),
                            ]).join(' | ')}
                        />
                    );
                })}
            />

            <Divider />
            <WDPMenuHeader primaryText="Others" />
            <WDPMenuTemplateChangerItem
                leftIcon={<IconStyle />}
                primaryText="Templates"
                template={template}
                secondaryText={template}
                onTemplateChanged={onTemplateChanged}
            />
        </List>
    );
});

export default WidgetPickerMenu;



/** WEBPACK FOOTER **
 ** ../src/dash/front/widget-picker/components/PickerMenu.js
 **/